import useGetCurrentUserDocument from "./useGetCurrentUserDocument";
import { useGetRegenerationStatusQuery } from "../api/documents";

export const useDocumentGenState = (documentId?: string) => {
  const {
    document,
    isLoading: isDocumentLoading,
    error: documentError,
  } = useGetCurrentUserDocument();

  // Use provided documentId or fall back to current user document
  const targetDocumentId = documentId ?? document?.id ?? "";
  const shouldSkip = !targetDocumentId;

  const {
    data: regenerationStatus,
    isLoading: isRegenerationStatusLoading,
    error: regenerationStatusError,
  } = useGetRegenerationStatusQuery(targetDocumentId, {
    skip: shouldSkip,
  });

  return {
    needsRegeneration:
      (regenerationStatus?.needsRegeneration ?? false) &&
      document?.lastGeneratedInputHash !== "bubble import", // todo: reconcile this with useDocumentModifiedState
    regenerationReason: regenerationStatus?.reason ?? null,
    lastGeneratedAt: regenerationStatus?.lastGeneratedAt ?? null,
    currentInputHash: regenerationStatus?.currentInputHash ?? null,
    lastGeneratedInputHash: regenerationStatus?.lastGeneratedInputHash ?? null,
    documentGeneratedAt: regenerationStatus?.documentGeneratedAt ?? null,
    userAMadeChanges: Boolean(regenerationStatus?.userAMadeChanges),
    userBMadeChanges: Boolean(regenerationStatus?.userBMadeChanges),
    isLoading:
      (documentId ? false : isDocumentLoading) || isRegenerationStatusLoading,
    error: (documentId ? null : documentError) ?? regenerationStatusError,
  };
};
